import ActionTypeZona from "../ActionTypeZona";
import ActionZonaSet from "../ActionZonaSet";

export default class GuardarZona extends ActionTypeZona {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = true;
        nuevoEstado.flag.procesandoComandoCrear = true;
        new ActionZonaSet("rowSelected", null).ejecutar(estado,nuevoEstado);
        // new ActionZonaSet("nombre", "").ejecutar(estado,nuevoEstado);
                
        // nuevoEstado.flag.sensorDeAccionGuardar = !(estado.flag.sensorDeAccionGuardar);
        // nuevoEstado.flag.sensorDeAccionGuardar = this.payload;
        return nuevoEstado;
    }
}
